/* ===========================================
   ZORGELOOSTHUYS — THEME JS v2
   =========================================== */

document.addEventListener('DOMContentLoaded', function () {

  // ---- MOBILE MENU ----
  var toggle = document.querySelector('.mobile-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  // ---- ACTIVE NAV ----
  var path = window.location.pathname;
  document.querySelectorAll('.nav-link, .mobile-nav__link').forEach(function (link) {
    var href = link.getAttribute('href') || '';
    if (href === '/' && path === '/') link.classList.add('nav-link--active');
    else if (href !== '/' && path.startsWith(href)) link.classList.add('nav-link--active');
  });

  // ---- PRODUCT THUMBNAILS ----
  var thumbs = document.querySelectorAll('.product-page__thumb');
  var mainImg = document.getElementById('MainProductImage');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.src) {
        mainImg.src = thumb.dataset.src;
        mainImg.srcset = '';
      }
    });
  });

  // ---- QUANTITY BUTTONS ----
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('.product-page__qty').querySelector('.qty-input');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'minus' && val > 1) input.value = val - 1;
      if (btn.dataset.action === 'plus') input.value = val + 1;
    });
  });

  // ---- WMO CHECKER ----
  initWmoChecker();

  // ---- COOKIE BANNER ----
  initCookieBanner();

  // ---- PRODUCT VIEW TOGGLE (grid / list) ----
  initViewToggle();

  // ---- SMOOTH SCROLL ----
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});

/* ---- PRODUCT VIEW TOGGLE ---- */
function initViewToggle() {
  var toggleGroup = document.querySelector('.view-toggle');
  var grid = document.getElementById('ProductGrid');
  if (!toggleGroup || !grid) return;

  var STORAGE_KEY = 'zt_product_view';
  var buttons = toggleGroup.querySelectorAll('.view-toggle-btn');

  function setView(view) {
    grid.classList.toggle('list-view', view === 'list');
    buttons.forEach(function (b) {
      var isActive = b.dataset.view === view;
      b.classList.toggle('active', isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    try { localStorage.setItem(STORAGE_KEY, view); } catch (e) { /* ignore */ }
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () { setView(b.dataset.view); });
  });

  var saved = null;
  try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) { /* ignore */ }
  setView(saved === 'list' ? 'list' : 'grid');
}

/* ---- WMO CHECKER LOGIC ---- */
var WMO_GEMEENTES = {
  'zutphen':      'https://www.zutphen.nl/inwoners/zorg-en-ondersteuning',
  'lochem':       'https://www.lochem.nl/inwoners/zorg-welzijn-en-werk',
  'apeldoorn':    'https://www.apeldoorn.nl/zorg-en-ondersteuning',
  'arnhem':       'https://www.arnhem.nl/Inwoners/zorg_en_welzijn',
  'nijmegen':     'https://www.nijmegen.nl/diensten/zorg-en-ondersteuning/',
  'ede':          'https://www.ede.nl/inwoners/zorg-welzijn-en-gezondheid/',
  'wageningen':   'https://www.wageningen.nl/inwoners/zorg-welzijn-en-werk/',
  'doetinchem':   'https://www.doetinchem.nl/zorg-en-welzijn',
  'tiel':         'https://www.tiel.nl/zorg-en-welzijn',
  'harderwijk':   'https://www.harderwijk.nl/zorg-welzijn-en-werk',
  'deventer':     'https://www.deventer.nl/zorg-en-onderwijs',
  'zwolle':       'https://www.zwolle.nl/zorg-en-welzijn',
  'almelo':       'https://www.almelo.nl/inwoners/zorg-welzijn-en-werk',
  'enschede':     'https://www.enschede.nl/zorg-welzijn-en-werk',
  'hengelo':      'https://www.hengelo.nl/inwoners/zorg-welzijn-en-werk',
  'kampen':       'https://www.kampen.nl/inwoners/zorg-welzijn-en-werk',
  'hardenberg':   'https://www.hardenberg.nl/inwoners/zorg-welzijn-en-werk',
  'oldenzaal':    'https://www.oldenzaal.nl/zorg-welzijn-en-werk',
  'raalte':       'https://www.raalte.nl/zorg-en-welzijn',
  'dalfsen':      'https://www.dalfsen.nl/zorg-en-welzijn',
  'ommen':        'https://www.ommen.nl/inwoners/zorg-welzijn-en-werk',
  'steenwijk':    'https://www.steenwijkerland.nl/zorg-en-welzijn',
  'borne':        'https://www.borne.nl/inwoners/zorg-welzijn-en-werk',
  'rijssen':      'https://www.rijssen-holten.nl/inwoners/zorg-welzijn-en-werk',
  'holten':       'https://www.rijssen-holten.nl/inwoners/zorg-welzijn-en-werk'
};

function initWmoChecker() {
  var checker = document.getElementById('WmoChecker');
  if (!checker) return;

  var steps   = checker.querySelectorAll('.wmo-step');
  var dots    = checker.querySelectorAll('.wmo-progress__dot');
  var result  = checker.querySelector('.wmo-result');
  var cityInput  = checker.querySelector('#WmoCity');
  var citySubmit = checker.querySelector('.wmo-city-submit');
  var current = 0;
  var answers = {};
  var city    = '';

  function showStep(index) {
    steps.forEach(function (s, i) { s.classList.toggle('active', i === index); });
    dots.forEach(function (d, i)  { d.classList.toggle('active', i <= index); });
  }

  function getGemeenteLink(cityName) {
    var key = cityName.toLowerCase().trim().replace(/\s+/g, ' ');
    if (WMO_GEMEENTES[key]) {
      return { url: WMO_GEMEENTES[key], known: true };
    }
    return {
      url: 'https://www.google.com/search?q=' + encodeURIComponent('WMO aanvraag ' + cityName),
      known: false
    };
  }

  function calcResult() {
    var positiveCount = 0;
    [0,1,2].forEach(function(i) { if (answers[i] === 'ja') positiveCount++; });

    result.classList.add('show');
    result.classList.remove('wmo-result--positive', 'wmo-result--info', 'wmo-result--warning');
    steps.forEach(function(s) { s.classList.remove('active'); });

    var titleEl  = result.querySelector('.wmo-result__title');
    var textEl   = result.querySelector('.wmo-result__text');
    var iconEl   = result.querySelector('.wmo-result__icon');
    var listEl   = result.querySelector('.wmo-result__checklist');
    var cityEl   = result.querySelector('.wmo-result__city');
    var btnEl    = result.querySelector('.wmo-result__gemeente-btn');

    var link = getGemeenteLink(city);
    var niceCity = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();

    if (positiveCount >= 3) {
      // Sterke indicatie
      result.classList.add('wmo-result--positive');
      iconEl.textContent  = '✓';
      titleEl.textContent = 'Grote kans op WMO-ondersteuning';
      textEl.innerHTML =
        'Op basis van uw antwoorden lijkt u <strong>sterke gronden</strong> te hebben voor een WMO-aanvraag bij uw gemeente. ' +
        'De gemeente beoordeelt vervolgens welke voorzieningen het best bij uw situatie passen, van een eenvoudige aanpassing tot een complete oplossing.';
      listEl.innerHTML =
        '<div class="wmo-check-item"><span class="wmo-check-mark">✓</span> Uw zelfredzaamheid is beperkt</div>' +
        '<div class="wmo-check-item"><span class="wmo-check-mark">✓</span> U woont zelfstandig thuis</div>' +
        '<div class="wmo-check-item"><span class="wmo-check-mark">✓</span> Dagelijkse handelingen gaan moeilijk</div>';
    } else if (positiveCount === 2) {
      // Matige indicatie
      result.classList.add('wmo-result--info');
      iconEl.textContent  = 'i';
      titleEl.textContent = 'Mogelijk komt u in aanmerking';
      textEl.innerHTML =
        'Op basis van uw antwoorden is er een <strong>redelijke kans</strong> dat WMO-ondersteuning voor u van toepassing is. ' +
        'Uw gemeente voert een persoonlijk gesprek (het "keukentafelgesprek") om uw situatie in te schatten. ' +
        'Wij kunnen u helpen bij de aanvraag en weten wat er verwacht wordt.';
    } else {
      // Zwakke indicatie
      result.classList.add('wmo-result--warning');
      iconEl.textContent  = '?';
      titleEl.textContent = 'WMO lijkt minder voor de hand liggend';
      textEl.innerHTML =
        'Op basis van uw antwoorden lijkt een WMO-vergoeding minder waarschijnlijk, maar iedere situatie is anders. ' +
        'Vraag bij twijfel altijd advies bij uw gemeente, dat kan geen kwaad. ' +
        'Wij bieden ook oplossingen <strong>buiten de WMO om</strong>, in verschillende prijsklassen.';
    }

    if (city) {
      if (link.known) {
        cityEl.innerHTML = 'Uw gemeente: <strong>' + niceCity + '</strong> &nbsp;·&nbsp; Wij hebben een directe link gevonden naar de WMO-informatie.';
      } else {
        cityEl.innerHTML = 'Uw gemeente: <strong>' + niceCity + '</strong> &nbsp;·&nbsp; Wij openen voor u een zoekresultaat naar de WMO-pagina van uw gemeente.';
      }
      btnEl.href = link.url;
      btnEl.textContent = link.known ? ('Ga naar gemeente ' + niceCity) : ('Zoek WMO ' + niceCity);
      btnEl.style.display = '';
    } else {
      cityEl.innerHTML = '';
      btnEl.style.display = 'none';
    }
  }

  checker.querySelectorAll('.wmo-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var step    = opt.closest('.wmo-step');
      var stepNum = parseInt(step.dataset.step);
      answers[stepNum] = opt.dataset.value;

      var next = stepNum + 1;
      if (next < steps.length) {
        current = next;
        showStep(current);
      } else {
        calcResult();
      }
    });
  });

  if (citySubmit && cityInput) {
    var submitCity = function() {
      var val = cityInput.value.trim();
      if (val.length < 2) {
        cityInput.focus();
        cityInput.classList.add('wmo-city-field--error');
        return;
      }
      cityInput.classList.remove('wmo-city-field--error');
      city = val;
      calcResult();
    };
    citySubmit.addEventListener('click', submitCity);
    cityInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); submitCity(); }
    });
  }

  checker.querySelectorAll('.wmo-btn-restart').forEach(function(btn) {
    btn.addEventListener('click', function() {
      answers  = {};
      current  = 0;
      city     = '';
      if (cityInput) cityInput.value = '';
      result.classList.remove('show', 'wmo-result--positive', 'wmo-result--info', 'wmo-result--warning');
      showStep(0);
    });
  });

  showStep(0);
}

/* ---- COOKIE BANNER ---- */
function initCookieBanner() {
  var STORAGE_KEY = 'zt_cookie_consent_v1';
  var banner      = document.getElementById('CookieBanner');
  if (!banner) return;

  var prefsBlock  = banner.querySelector('#CookieBannerPrefs');
  var defaultText = banner.querySelector('#CookieBannerDefaultText');
  var saveBtn     = banner.querySelector('[data-cookie-action="save-prefs"]');
  var analyticsCb = banner.querySelector('#CookiePrefAnalytics');
  var marketingCb = banner.querySelector('#CookiePrefMarketing');

  function readConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function saveConsent(consent) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        functional: true,
        analytics:  !!consent.analytics,
        marketing:  !!consent.marketing,
        timestamp:  new Date().toISOString()
      }));
    } catch (e) { /* ignore */ }
  }

  function applyConsent(consent) {
    if (consent.analytics && window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': consent.marketing ? 'granted' : 'denied'
      });
    }
    document.documentElement.dataset.consentAnalytics = consent.analytics ? '1' : '0';
    document.documentElement.dataset.consentMarketing = consent.marketing ? '1' : '0';
  }

  function hideBanner() {
    banner.classList.remove('cookie-banner--open');
    setTimeout(function() { banner.hidden = true; }, 300);
  }

  function showBanner() {
    banner.hidden = false;
    requestAnimationFrame(function() {
      banner.classList.add('cookie-banner--open');
    });
  }

  function showPrefs() {
    prefsBlock.hidden = false;
    defaultText.hidden = true;
    saveBtn.hidden = false;
  }

  banner.querySelectorAll('[data-cookie-action]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var action = btn.dataset.cookieAction;
      if (action === 'accept-all') {
        var c = { analytics: true, marketing: true };
        saveConsent(c); applyConsent(c); hideBanner();
      } else if (action === 'reject-all') {
        var r = { analytics: false, marketing: false };
        saveConsent(r); applyConsent(r); hideBanner();
      } else if (action === 'toggle-prefs') {
        showPrefs();
      } else if (action === 'save-prefs') {
        var p = {
          analytics: analyticsCb && analyticsCb.checked,
          marketing: marketingCb && marketingCb.checked
        };
        saveConsent(p); applyConsent(p); hideBanner();
      }
    });
  });

  document.querySelectorAll('[data-cookie-action="open"]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var existing = readConsent();
      if (existing) {
        if (analyticsCb) analyticsCb.checked = !!existing.analytics;
        if (marketingCb) marketingCb.checked = !!existing.marketing;
        showPrefs();
      }
      showBanner();
    });
  });

  var existing = readConsent();
  if (existing) {
    applyConsent(existing);
  } else {
    setTimeout(showBanner, 600);
  }
}
